// extracted by mini-css-extract-plugin
export default {"heading":"Heading_heading__Rj88U","logo":"Heading_logo__qxP2C","sunPic":"Heading_sunPic__byC5q","picture":"Heading_picture__NvQuN"};